<template>
  <!-- 视频播放页面 -->
  <div id="detail-video" v-cloak>
    <!-- 视频里面的提示 -->
    <div class="video-tips" v-show="showBack">
      <img
        @click="goBack"
        src="../../assets/img/common-img/back-icon.png"
        alt=""
        class="vbtn back-icon"
      >
      <img
        v-if="!isFavort && sendImg === false"
        src="../../assets/img/groupDetail/guanzhu@2x.png"
        alt=""
        class="vbtn"
        :class="[isMp? 'collect-icon' : 'collect-isweb-icon']"
        @click="collectVideo"
      >
      <img
        v-if="isFavort && sendImg === false"
        src="../../assets/img/groupDetail/shiguanzhu@2x.png"
        alt=""
        class="vbtn"
        :class="[isMp? 'collect-icon' : 'collect-isweb-icon']"
        @click="cancleCollectVideo"
      >
      <img
        v-if="isMp"
        src="../../assets/img/groupDetail/fenxiang@2x.png"
        alt=""
        class="vbtn share-icon"
        @click="goShare"
      >
    </div>
    <!-- end -->
    <div class="share-cover" v-show="showShare" @click="hideShare">
      <img src="../../assets/img/groupDetail/share-cover.png" alt="">
    </div>
    <div class="group-view">
      <div
        v-show="tabIndex == 1 && !isPlayKownLedgeVideo"
        class="content-box"
        v-html="itemData.zm_content"
      ></div>
      <div
        v-show="tabIndex == 1 && isPlayKownLedgeVideo"
        class="content-box"
        v-html="kownLedgeContent"
      ></div>
      <!-- 封面 -->
      <div class="group-bg">
        <div class="group-overflow">
          <div class="group-img" :style="{ 'background-image': 'url('+ groupDetail.image+ ')'}"></div>
          <div class="group-img cover-shadow"></div>
        </div>
        <!-- <img
          src="../../assets/img/groupDetail/bofang@2x.png"
          alt=""
          @click="goVideoDetail(itemData.item_id)"
        >-->
      </div>
      <div v-show="tabIndex == 0" class="content-box noBottom">
        <!-- 视频名称 -->
        <div class="video-name-box">
          <div class="video-name">{{itemData.group_name}}</div>
          <div class="symptom">
            <div
              class="fs-20"
              :class="'symptom'+(k+1)"
              v-for="(v, k) in itemData.symptoms"
              v-if="k<3"
              :key="k"
              @click="goSearch(v.symptom_name)"
            >
              <span class="centerv">{{v.symptom_name}}</span>
              <span class="centerH">{{v.symptom_name}}</span>
            </div>
          </div>
          <div class="statis-data">
            <div class="watch-numb">
              <p class="fs-24 c-666">观看次数</p>
              <p class="fs-28 c333">{{amountData.view}}</p>
            </div>
            <div class="collect-numb">
              <p class="fs-24 c-666">收藏人数</p>
              <p class="fs-28 c333">{{amountData.collect}}</p>
            </div>
            <div class="relative-doctor-numb" v-if="!inMiniProgram">
              <p class="fs-24 c-666">相关医生</p>
              <p class="fs-28 c333">{{amountData.doctor}}</p>
            </div>
          </div>
          <div class="more-box">
            <span class="name-tips" :class="{tipsActive:isShowTips}">{{itemData.describe}}</span>
            <img
              src="../../assets/img/see-doctor-icon/1-3jianjiexiala@2x@2x.png"
              alt=""
              :class="[isShowTips?'more-icon':'more-icon2']"
              @click.stop="isShowTips = !isShowTips"
            >
          </div>
          <!-- <van-button
            v-if="itemData.group_name === '重症手足口病'"
            @click="goInsurance"
            type="primary"
            class="go_insurance"
          >点我，给宝宝提供健康保障</van-button>-->
        </div>
        <!-- end -->
        <!-- 视频图文选集 -->
        <div class="select-box border-css" v-if="groupDetail.spjh">
          <div class="select-title">
            <span class="title-text">系列视频</span>
          </div>
          <div class="select-video-item-box-wrap">
            <div
              v-for="(item, iIndex) in groupDetail.spjh"
              :key="iIndex"
              class="select-video-item"
              :class="[computedVideoItemClass(item)]"
            >
              <h4 class="symptom-title">{{ item.tag_name && item.tag_name.split('-')[1] }}</h4>
              <!-- @click="goVideoDetail(item.item_id)" -->
              <div class="symptom-video-bg">
                <!-- h5原生组件 -->
                <video
                  class="origin-widgt"
                  :src="item.aliyun_mp4_play_url"
                  :poster="item.image"
                  controls
                  style="width: 100%"
                  preload="auto"
                  x-webkit-airplay="true"
                  x5-playsinline="true"
                  webkit-playsinline="true"
                  playsinline="true"
                  v-show="(!showShare && showPlay[iIndex] && !isShowdouyinVideo)"
                ></video>
                <!-- 点击播放 -->
                <img
                  class="symptom-video-img"
                  :src="item.image"
                  alt=""
                  @click="playItem(item.item_id, iIndex)"
                  v-show="showShare || !showPlay[iIndex] || isShowdouyinVideo"
                >
                <img
                  class="icon-play"
                  src="../../assets/img/groupDetail/icon-play.png"
                  alt=""
                  v-if="item.image"
                  v-show="showShare || !showPlay[iIndex] || isShowdouyinVideo"
                  @click="playItem(item.item_id, iIndex)"
                >
                <!-- 试看 -->
                <div class="pay-panel" v-if="item.issf == '1' && !item.jf && !showPlay[iIndex]">
                  <img class="cover-url" :src="item.image" alt="">
                  <img class="mask" src="@/assets/img/videoDetail/mask.png" alt="">
                  <template v-if="inMiniProgram">
                    <img
                      @click="playItem(item.item_id, iIndex)"
                      class="shown-btn-inMiniProgram"
                      src="@/assets/img/videoDetail/shown-btn.png"
                      alt=""
                    >
                  </template>
                  <template v-else>
                    <!-- 试看按钮 -->
                    <img
                      @click="playItem(item.item_id, iIndex)"
                      class="shown-btn"
                      src="@/assets/img/videoDetail/shown-btn.png"
                      alt=""
                    >
                    <!-- 完整观看 -->
                    <img
                      @click="buyVideo(item.item_id)"
                      class="full-watch-btn"
                      src="@/assets/img/videoDetail/full-watch.png"
                      alt=""
                    >
                    <div
                      v-if="group_id == 69"
                      class="discount-bg full"
                    >{{ parseInt(item.spjg)/100 }}元抢先看</div>
                    <div class="discount-bg full">优惠价仅{{ parseInt(item.spjg)/100 }}元</div>
                  </template>
                </div>
                <!-- end -->
                <!-- 收费视频观看结束而且没付款 -->
                <div
                  class="pay-panel pay"
                  v-if="item.issf==1 && item.jf == false && showPay[iIndex]"
                >
                  <!-- <p >试看结束，本片需购买观看，请先购买</p> -->
                  <p
                    v-if="inMiniProgram"
                    style="top: 50%;transform: translateY(-50%);line-height: 24px;"
                  >试看结束，谢谢观看</p>
                  <p
                    v-if="group_id != 69 && !inMiniProgram"
                  >主人，原创不易，打赏{{ parseInt(item.spjg)/100 }}元，我就是你的人啦！</p>
                  <p
                    v-if="group_id == 69 && !inMiniProgram"
                  >主人，原创不易，打赏{{ parseInt(item.spjg)/100 }}元抢先看哦</p>
                  <!-- 立即购买 -->
                  <img
                    @click="buyVideo(item.item_id)"
                    class="buy-at-once"
                    src="@/assets/img/videoDetail/buy.png"
                    alt=""
                    v-if="!inMiniProgram"
                  >
                  <!-- 优惠价 -->
                  <div
                    v-if="group_id != 69 && !inMiniProgram"
                    @click="buyVideo(item.item_id)"
                    class="discount-bg desc"
                  >优惠价仅{{ parseInt(item.spjg)/100 }}元</div>
                  <div
                    v-if="group_id == 69 && !inMiniProgram"
                    @click="buyVideo(item.item_id)"
                    class="discount-bg desc"
                  >{{ parseInt(item.spjg)/100 }}元抢先看</div>
                </div>
              </div>
              <div class="symptom-summary-title">
                <!-- {{item.short_name && item.short_name.split("：")[1]}} -->
                <span
                  v-if="item.issf == '2' || item.jf"
                  class="rich-text"
                  @click="goRichTxt(item.item_id, item.group_id, item.image)"
                >阅读图文</span>
              </div>
              <div class="symptom-summary">{{item.describe}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="other-sorts border-css" v-if="douyinList.length !== 0">
        <p class="other-name title-css">小知识点</p>
        <!-- <div class="kownLedge" v-for="(douyin, k) in douyinList" :key="k" @click="goKnowledge(douyin)" v-if="k<5"> -->
        <div class="kownLedge" v-for="(douyin, k) in douyinList" :key="k"  v-if="k<5">
          <img src="../../assets/img/videoDetail/kownLedge.png" alt="" class="icon">
          <a class="" :href="'http://www.shendutv.com/video/baidu-douyin-detail/'+douyin.id+'.html?v3'">{{douyin.video_title}}</a>
        </div>
        <div class="kownLedge-more" v-if="douyinList.length>5" @click="seeAlldouyinVideo">
          查看更多
          <img src="../../assets/img/videoDetail/knowMore.png" alt="">
        </div>
      </div>
      <!-- 查看更多遮罩层 -->
      <!-- <div class="mask-layout" v-if="isShowdouyinVideo" @click="closeAlldouyinVideo"></div> -->

      <!-- 查看更多弹出层 -->
      <!-- <transition name="popup"> -->
      <van-popup v-model="isShowdouyinVideo" position="bottom" :style="{ height: '60%' }">
        <div class="groupVideosPopUp">
          <div class="header">
            <p>全部小知识点</p>
            <img src="../../assets/img/videoDetail/close.png" alt="" @click="closeAlldouyinVideo">
          </div>
          <div class="items-container">
            <!-- <div class="kownLedge" v-for="(douyin, k) in douyinList" :key="k" @click="goKnowledge(douyin)"> -->
            <div class="kownLedge" v-for="(douyin, k) in douyinList" :key="k">
              <img src="../../assets/img/videoDetail/kownLedge.png" alt="" class="icon">
              <a class="" :href="'http://www.shendutv.com/video/baidu-douyin-detail/'+douyin.id+'.html?v3'">{{douyin.video_title}}</a>
            </div>
          </div>
        </div>
      </van-popup>
      <!-- </transition> -->
      <div class="content-box-normal" v-if="relativeDoctors && !inMiniProgram">
        <!-- top5医生推荐 -->
        <div class="select-title">
          <span class="title-text">top5医生推荐</span>
          <img src="../../assets/img/groupDetail/watchmore@2x.png" alt="" @click="goDoctorSearch">
        </div>
        <div class="doctor-wrapper">
          <ul class="doctor-top5-bg">
            <!-- 众包医生 -->
            <li class="doctor-top5" v-if="relativeDoctors" @click="goRouter('/SdInquiry')">
              <img class="top-numb-bg" src="../../assets/img/groupDetail/top1@2x.png" alt="">
              <span class="top-numb">TOP.1</span>
              <div class="doctor-img">
                <img src="../../assets/img/order-img/no-pay.png" alt="">
              </div>
              <p class="doctor-name">三甲医生</p>
              <p class="doctor-desc">3分钟极速回复</p>
              <div class="doctor-ask">
                <div class="ask-numb-bg">
                  <p class="ask-numb fs-24">971次</p>
                  <p class="ask-numbtext fs-20">接诊量</p>
                </div>
                <div class="ask-price-bg">
                  <p class="ask-price fs-24">¥9.9/次</p>
                  <p class="ask-pricetext fs-20">我也问</p>
                </div>
                <!-- 后台设置的医生,这里不能格式化代码 -->
              </div>
            </li>
            <li
              class="doctor-top5"
              v-for="(doctor, index) in relativeDoctors"
              :key="index"
              v-if="index<4"
              @click.prevent="goRouter('/SdDoctorMsg',doctor.doctor_id)"
            >
              <img class="top-numb-bg" src="../../assets/img/groupDetail/top2@2x.png" alt="">
              <span class="top-numb">TOP.{{index+2}}</span>
              <div class="doctor-img">
                <img :src="doctor.image" alt="">
              </div>
              <p class="doctor-name">{{doctor.name}}</p>
              <p class="doctor-desc">{{doctor.clinic_name}} {{doctor.title}}</p>
              <div class="doctor-ask">
                <div class="ask-numb-bg" @click.stop="goAsk(doctor.doctor_id)">
                  <p class="ask-numb fs-24">{{doctor.reply_num}}次</p>
                  <p class="ask-numbtext fs-20">接诊量</p>
                </div>
                <div class="ask-price-bg" @click.stop="goAsk(doctor.doctor_id)">
                  <p class="ask-price fs-24">¥{{(doctor.price/100)}}/次</p>
                  <p class="ask-pricetext fs-20">我也问</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- end -->
      </div>
      <div v-if="tabIndex == 0" class="content-box-normal">
        <p class="other-name title-css">相关视频</p>
      </div>
      <div v-if="!relateVideos">空空如也~</div>
      <div class="related-video-bg">
        <div v-show="tabIndex == 0" class="related-video-swiper" ref="related-swiper-box">
          <template v-for="item in relateVideos.groupList">
            <div
              class="video-swiper-item"
              v-if="item.group_id != group_id"
              ref="video-swiper-item"
              :key="item.group_name"
              @click="goGroupDetail(item.spjh[0].item_id)"
            >
              <!--病种图片与 名字-->
              <p class="header">
                <img class="avatur" :src="item.fmt">
                <span class="b_FS-36 c_333 font-medium">{{ item.group_name }}</span>
              </p>
              <!-- end -->
            </div>
          </template>
        </div>
      </div>
      <!-- 评论 -->
      <div class="comment" id="comment-list">
        <p class="comment-title title-css">评论</p>
        <!-- 评论输入框 -->
        <div class="go-comment">
          <img
            src="../../assets/img/see-doctor-icon/send-comment.png"
            alt=""
            class="heart-icon"
            @click="addComment"
          >
          <input
            ref="commentRef"
            type="text"
            placeholder="给深读君留言呗~"
            class="comment-text"
            v-model="commentInput"
            @keyup.enter="addComment"
          >
        </div>
        <!-- 评论区 -->
        <ul class="comment-list">
          <li class="item-list" v-for="(v,k) in commentList" :key="k">
            <div class="item-left">
              <img
                :src="v.avatar && v.avatar.trim() ? ((v.avatar.indexOf('shendutv') > -1 || v.avatar.indexOf('http') > -1)? v.avatar : crhost+v.avatar) : require('@/assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png')"
                alt=""
                class="user-icon"
              >
            </div>
            <div class="item-right">
              <div class="user-info">
                <span class="user-mobile">{{v.nickname}}</span>
                <img
                  src="../../assets/img/see-doctor-icon/1-3pinglunshanchu@2x.png"
                  alt=""
                  class="delete-icon"
                  @click="deleteComment(v.id)"
                  v-if="isself == v.uid"
                >
              </div>
              <p class="comment-text" v-html="emoji(v.comment)"></p>
              <!-- <p class="comment-text">{{v.comment}}</p> -->
              <span class="comment-time">{{v.time_describe}}</span>
            </div>
          </li>
          <li class="item-bottom" v-if="commentList.length == 0">
            <p>还没有评论，要不您来两句~</p>
          </li>
        </ul>
        <div class="no-more" v-if="commentList.length > 4">没有更多了~</div>
      </div>
    </div>
    <!-- 蒙层 -->
    <div v-if="showMongolia" class="mongolia" @touchstart="closeMongolia"></div>
    <van-popup v-model="isShowDepartImage">
      <img
        @click="isShowDepartImage = false"
        class="isShowDepart"
        src="@/assets/img/videoDetail/zaoxie-advert.png"
      >
    </van-popup>
  </div>
</template>

<script>
  /* 声明：1、sessionStorage不适用于keep-alive，如果一定用keep-alive，请在它的生命周期中用（actived、、） 
                        2、用了keep-alive后，监听路由变化要做这个判断
                */
  //滑动处理
  var startX, startY;
  // import VideoPlayer from '../public/VideoPlayer'
  import iMp from "@/common/isMp";
  import TcPlayer from "../public/TcPlayer";
  import EventBus from "../../common/eventBus.js";
  import { currentHost } from "@/config";
  import { Wechat } from "@/common/Wechat";
  import { emoji } from "@/common/emoji";
  import wx from "weixin-js-sdk";
  import Vue from "Vue";
  import VConsole from "vconsole/dist/vconsole.min.js";
  import {
    shareAccount,
    addViewHistory,
    subjectTj,
    creatItemOrder,
    playRecord,
    videoDetail,
    relatedDisease,
    groupCommetAdd,
    groupCommetDelete,
    videoCollectAdd,
    videoCollectDelete,
    videoCollect,
    recommendDoctorWx,
    groupComment,
    douyinList,
    otherGroup,
    selectOrderStatus,
    subject
  } from "@/api/index";
  // import { Popup } from 'vant';

  // import { videoPlayer } from 'vue-video-player';

  // import emoji from 'emoji'
  export default {
    components: {
      // 'video-player': videoPlayer,
      "tc-player": TcPlayer
    },
    data() {
      return {
        crhost: currentHost,
        itemId: "",
        itemData: [],
        play_item_id: "", // 当前播放或选中的视频的itemid
        departmentId: "",
        group_id: "",
        doctor_id: "",
        relatedDiseases: [],
        relateVideos: {
          dpInfo: {},
          groupList: {}
        },
        isShowTips: true,
        url: "",
        isFavort: null,
        sendImg: false, // 控制发送图标
        activeIndex: null,
        backPath: "", // 记录要回退的地址s
        showShdow: true,
        iosBottom: null,
        showBack: true,
        showMongolia: false,
        tabIndex: 0, // 视频：0 图文 ： 1
        isShowBuyPanel: false, // 是否显示收费面板
        isAutoLoad: false,
        payStatusTimer: null,
        kownLedgeContent: "",
        isShowDepartImage: false, // 是否显示弹窗
        playTime: 0,
        relativeDoctors: [], // 相关医生
        startScrollPos: null,
        currentSwiperIndex: 0,
        isShowdouyinVideo: false,
        currentGroupSpjh: [],
        showShare: false,
        groupDetail: {
          spjh: [
            {
              summary: "加载中..."
            }
          ]
        },
        isMp: true,
        amountData: { view: "加载中", collect: "加载中", doctor: "加载中" },
        playerOptions: {
          //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "video/mp4",
              src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" //你的视频地址（必填）
            }
          ],
          poster: "poster.jpg", //你的封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          //        controlBar: {
          //          timeDivider: true,
          //          durationDisplay: true,
          //          remainingTimeDisplay: false,
          //          fullscreenToggle: true  //全屏按钮
          //        }
        },
        douyinList: [],
        commentInput: "",
        showPlay: [],
        showPay: [],
        isShowdouyinVideo: false,
        commentList: [],
        isself: localStorage.getItem("uid") || "",
        currentScrollTop: 0
      };
    },
    mixins: [iMp],
    created() {
      if (this.$route.query.itemId) {
        this.itemId = this.$route.query.itemId; //! !!!!!!!!!!!写死的一个假数据
      }
      if (localStorage.getItem("commentData-group") !== "") {
        // 评论信息
        this.commentInput = localStorage.getItem("commentData-group");
      }
      this.fetch();
      this.watchHistory();
    },
    beforeMount() {
      this.activeIndex = this.$route.query.itemId;
      if (localStorage.getItem("isMp") == "noIsWebH5") {
        this.isMp = false;
      }
    },
    mounted() {
      this.$route.query.showVconsole ? this.showVconsole() : ''
      let checkErr = setTimeout(() => {
        if (this.amountData.view == "加载中") {
          console.log("加载出错，重新加载");
          window.reload();
        } else {
          clearTimeout(checkErr);
        }
      }, 3000);
      if (this.$route.query.itemId) {
      }
      // 定制运营功能
      let staff_id, url_id; // 人员id、URL链接id
      if (this.$route.query.staff_id) {
        staff_id = this.$route.query.staff_id;
        url_id = this.$route.query.url_id;
        localStorage.setItem("staff_id", staff_id);
        localStorage.setItem("url_id", url_id);
      } else {
        staff_id = localStorage.getItem("staff_id");
        url_id = localStorage.getItem("url_id");
      }
      this.$http.post(
        shareAccount,
        this.$ObjToFd({
          url: encodeURIComponent(location.href),
          staff_id,
          url_id
        })
      );

      // this.commentRef.blur()
      if (this.$route.path === "/SdDetailVideo") {
        this.showShdow = false;
      }
      let that = this;
      EventBus.$on("showBack", val => {
        that.showBack = val;
      });
      EventBus.$on("hiddenBack", val => {
        that.showBack = val;
      });
      if (localStorage.getItem("token")) {
        this.isCollect();
      }
    },
    activated() {
      this.itemId = this.$route.query.itemId;
      if (!sessionStorage.getItem("originRouter")) {
        sessionStorage.setItem("originRouter", this.$route.query.itemId);
      }
      this.isCollect();
    },
    deactivated() {},
    beforeRouteEnter(to, from, next) {
      const path = to.fullPath;
      const origin = location.origin;
      var obj = [
        "?from=timeline&isappinstalled=0",
        "?from=groupmessage&isappinstalled=0",
        "?from=singlemessage&isappinstalled=0"
      ];
      if (location.href.indexOf("?from=") > -1) {
        // this.$router.push("/index")
        console.log(origin + "/#" + to.fullPath);
        location = origin + "/#" + to.fullPath;
        return;
      }
      next(vm => {
        // 如果是从医生信息那边来的就让它可以后退到医生信息那边
        if (
          from.name == "SdDoctorMsg" &&
          sessionStorage.getItem("originRouter")
        ) {
          sessionStorage.removeItem("originRouter");
        }
        if (from.path !== vm.$route.path) {
          vm.backPath = from.path;
          if (from.path === "/SdDoctorMsg" || from.path === "/SdInquiry") {
            sessionStorage.setItem("videoBackPath", "/SdSeeDoctor");
          } else {
            sessionStorage.setItem("videoBackPath", vm.backPath);
          }
        }
      });
    },
    beforeDestroy() {
      EventBus.$off("showBack");
      EventBus.$off("hiddenBack");
      const doc = this.$refs["related-swiper-box"];
      clearInterval(doc.timer);
      clearInterval(this.iosBottom);
    },
    destroyed() {
      if (this.commentInput) {
        if (this.commentInput.length > 0) {
          localStorage.setItem("commentData-group", "");
          localStorage.setItem("commentData-group", this.commentInput);
        }
      }
      clearInterval(this.iosBottom);
    },
    watch: {
      // 深度观察监听
      $route: {
        handler: function(val, oldVal) {
          // this.fetch();
          // this.$toast({
          //   duration: 600,
          //   mask: true,
          //   message: "正在加载~"
          // });

          // 用了keep-alive后，监听路由变化要做这个判断
          if (val.path && val.path == "/SdGroupDetail") {
            this.fetch();
            this.$toast({
              duration: 600,
              mask: true,
              message: "正在加载~"
            });
          }
        },
        // immediate: true,
        deep: true
      },
      itemId(n, o) {
        // EventBus.$off('showBack')
        // EventBus.$off('hiddenBack')
        if (!o) {
          return;
        }
        this.isPlayKownLedgeVideo = false;
        this.fetch();
        this.playTime = 0; // 视频播放次数清零
        if (localStorage.getItem("token")) {
          this.isCollect();
        }
        window.scrollTo(0, 0);
      },
      showMongolia: {
        handler(n, o) {
          if (n === false) {
            clearInterval(this.iosBottom);
          }
        }
      }
    },
    inject: ["reload", "setGlobalCss"],
    beforeDestroy() {
      this.setGlobalCss(false);
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer);
      }
    },
    methods: {
      emoji: emoji,
      showVconsole() {
        let vConsole = new VConsole()
      },
      // 观看历史(需要和收费视频结合使用)
      watchHistory(type) {
        let params = {
          item_id: this.itemId,
          type
        };
        let url = addViewHistory;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {});
      },
      // 播放视频
      /* Vue.set() */
      /* 向响应式对象中添加一个属性，并确保这个新属性同样是响应式的，且触发视图更新。它必须用于向响应式对象上添加新属性，因为 Vue 无法探测普通的新增属性 (比如 this.myObject.newProperty = 'hi') */
      playItem(id, k) {
        this.currentIndex = k;
        this.play_item_id = id;
        let self = this;
        let cvideo = document.getElementsByTagName("video");
        self.showPlay.map((val, key) => {
          Vue.set(self.showPlay, key, false);
          cvideo[key] && cvideo[key].pause();
        });
        Vue.set(self.showPlay, k, true);
        cvideo[k].play();
      },
      // 图文富文本
      goRichTxt(item_id, group_id, rimg) {
        localStorage.setItem("richImage", rimg);
        let itemid = item_id || this.item_id || this.itemId;
        let groupid = group_id || this.group_id;
        this.$router.push(
          "/SdRichTxt?item_id=" + item_id + "&group_id=" + group_id
        );
      },
      // 小知识点
      getDouYinList() {
        this.$http
          .get(douyinList, {
            params: {
              department_id: this.departmentId,
              group_id: this.group_id
            }
          })
          .then(res => {
            this.douyinList = res.data.data;
          });
      },
      // 查看全部小知识点
      seeAlldouyinVideo() {
        this.isShowdouyinVideo = true;
      },
      closeAlldouyinVideo() {
        this.isShowdouyinVideo = false;
      },
      // 小知识点跳转
      goKnowledge(val) {
        // console.log("douyinItem", val);
        // localStorage.setItem("douyinItem", JSON.stringify(val));
        // this.$router.push({
        //   path: "/SdDouyin",
        //   query: {
        //     itemId: this.itemId
        //   }
        // });
        // window.location.href = 'http://wwwtest.shendutv.com/video/baidu-douyin-detail.html?id=48'
      },
      // 咨询医生
      goAsk(doctor_id) {
        this.$router.push({
          path: "/SdInquiry",
          query: {
            from: this.$route.fullPath,
            doctor_id: doctor_id
          }
        });
      },
      // 医生详情
      goRouter(val, id) {
        this.$router.push({ path: val, query: { doctorId: id } });
      },
      // 统计
      getAmount() {
        this.$http.get(subjectTj + "?group_id=" + this.group_id).then(res => {
          this.amountData = res.data.data;
        });
      },
      // 相关专题(相关视频)
      goGroupDetail(itemId) {
        // 由于跳转的是当前页面，this.$router.push不会更新当前组件
        this.$router.push("/SdGroupDetail?itemId=" + itemId);
        // location.reload();
        // this.fetch() //直接监听路由
      },

      // 查看更多医生
      goDoctorSearch() {
        let params = this.relateVideos.dpInfo;
        if (params) {
          this.$router.push({
            path: "/SdAskDoctor",
            query: { name: params.title, department_id: params.department_id }
          });
        } else {
          this.$router.push({
            path: "/SdAskDoctor"
          });
        }
      },
      // 跳转到篇幅视频
      goVideoDetail(itemId) {
        this.$router.push({
          path: "/SdDetailVideo",
          query: { itemId }
        });
      },
      // 分享功能测试
      goShare() {
        this.showShare = true;
      },
      hideShare() {
        this.showShare = false;
      },
      emoji: emoji,
      getRelatedVideos() {
        this.$http
          .get(otherGroup, {
            params: { department_id: this.departmentId }
          })
          .then(res => {
            this.relateVideos = res.data.data;
          });
      },
      //返回角度
      GetSlideAngle(dx, dy) {
        return (Math.atan2(dy, dx) * 180) / Math.PI;
      },

      //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      GetSlideDirection(startX, startY, endX, endY) {
        var dy = startY - endY;
        var dx = endX - startX;
        var result = 0;
        //如果滑动距离太短
        if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
          return result;
        }
        var angle = this.GetSlideAngle(dx, dy);
        if (angle >= -45 && angle < 45) {
          result = 4;
        } else if (angle >= 45 && angle < 135) {
          result = 1;
        } else if (angle >= -135 && angle < -45) {
          result = 2;
        } else if (
          (angle >= 135 && angle <= 180) ||
          (angle >= -180 && angle < -135)
        ) {
          result = 3;
        }
        return result;
      },
      recoverPos() {
        console.log("复位");
        const doc = this.$refs["video-swiper-item"][0];
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      skipNextSwiper() {
        this.currentSwiperIndex += 1;
        if (this.currentSwiperIndex >= this.relateVideos.groupList.length) {
          this.currentSwiperIndex = this.relateVideos.groupList.length - 1;
        }
        const doc = this.$refs["video-swiper-item"][this.currentSwiperIndex];
        console.log(doc.clientWidth * this.currentSwiperIndex);
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      skipPrevSwiper() {
        this.currentSwiperIndex -= 1;
        if (this.currentSwiperIndex < 0) {
          this.currentSwiperIndex = 0;
        }
        const doc = this.$refs["video-swiper-item"][this.currentSwiperIndex];
        console.log(
          doc.clientWidth * this.currentSwiperIndex,
          this.currentSwiperIndex
        );
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      buyVideo(item) {
        this.play_item_id = item;
        const token = localStorage.getItem("token");
        if (!token) {
          const routerPath = this.$route.fullPath;
          this.$router.push({
            path: "/sdLogin",
            query: {
              redirect: routerPath,
              loginFrom: routerPath
            }
          });
          return;
        }
        if (this.$isWexin) {
          // 微信支付
          this.weixinPay();
        } else {
          // 手机浏览器
          this.mobileBrowserPay();
        }
      },
      createPayParams() {
        const openid = localStorage.getItem("openid");
        console.log("createPayParamsopenid", openid);
        return {
          item_id: this.play_item_id,
          order_type: this.$isWexin ? 2 : 3,
          openid
        };
      },
      wechatPayCheck(order_number) {
        let step = 0;
        this.payStatusTimer = setInterval(() => {
          this.$http
            .get(selectOrderStatus, {
              params: { order_number }
            })
            .then(res => {
              const { is_pay, trade_status } = res.data.data;
              if (step > 5 * 60) {
                this.$toast("支付超时");
                location.reload();
                // this.$router.push('/SdAskOrder')
                return;
              }
              if (is_pay && trade_status == 2) {
                clearInterval(this.payStatusTimer);
                this.$toast("支付成功");
                location.reload();
                return;
              }
              step += 1;
            });
        }, 1000);
      },
      // 手机浏览器支付
      mobileBrowserPay() {
        const url = creatItemOrder;
        let params = this.createPayParams();
        console.log("mobileBrowserPay", params);
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const mweb_url = res.data.data.config.result.mweb_url;
            const order_number = res.data.data.order_number;
            this.orderNum = order_number;
            console.log(
              mweb_url +
                "&redirect_url=" +
                encodeURIComponent(
                  currentHost +
                    "/#/payCheck/" +
                    order_number +
                    "/video?itemId=" +
                    this.itemId
                )
            );
            location.href =
              mweb_url +
              "&redirect_url=" +
              encodeURIComponent(
                currentHost +
                  "/#/payCheck/" +
                  order_number +
                  "/video?itemId=" +
                  this.itemId
              );
          }
        });
      },
      // 微信支付
      weixinPay() {
        const { doctor_id } = this.$route.query;
        // 这里也可以封装到createPayParams，但是得分开终端，影响性能
        const openid = localStorage.getItem("openid") || this.urlOpenId();
        console.log("weixinPayopenid", openid);
        let params = {
          item_id: this.play_item_id,
          order_type: this.$isWexin ? 2 : 3,
          openid
        };
        console.log("weixinPayparams", params);
        const url = creatItemOrder;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const { prepayId, json } = res.data.data.config;
            const order_number = res.data.data.order_number;
            this.orderNum = order_number;
            if (WeixinJSBridge && prepayId !== "") {
              // 下单成功 WeixinJSBridge
              WeixinJSBridge.invoke("getBrandWCPayRequest", json, res => {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  this.wechatPayCheck(order_number);
                } else {
                  this.$toast("支付失败");
                  location.reload();
                }
              });
            }
          } else {
            this.$toast("抱歉，您的参数有误，请重新登录再试");
          }
        });
      },
      // 监控视频播放结束
      videoEnded() {
        if (this.itemData.issf == "1" && !this.itemData.jf) {
          this.isShowBuyPanel = true;
        }
      },
      // 监控视频播放， 但没次只记录一次
      videoPlay() {
        if (this.playTime > 0) {
          return;
        } else {
          const issf = this.itemData.issf; // 是否需要缴费
          const jf = this.itemData.jf; // 是否缴费
          const type = issf == 2 ? 1 : jf ? 1 : 2;
          if (localStorage.getItem("token")) {
            this.watchHistory(type);
          } else {
            let params = {
              item_id: this.itemId,
              type
            };
            let url = playRecord;
            this.$http.post(url, this.$ObjToFd(params)).then(res => {});
          }
          this.playTime += 1;
        }
      },
      computedVideoItemClass(item) {
        const issf = item.issf; // 是否需要购买 1 : 要收费 2. 不用收费
        const jf = item.jf; // 是否buy
        if (
          issf == "1" &&
          jf &&
          this.activeIndex == item.item_id &&
          !this.isPlayKownLedgeVideo
        ) {
          return "active";
        } else if (
          issf == "2" &&
          this.activeIndex == item.item_id &&
          !this.isPlayKownLedgeVideo
        ) {
          return "active";
        } else if (issf == "1" && !jf) {
          return "lock";
        }
        return "";
      },
      setTabIndex(tab) {
        if (tab == 0) {
          this.setGlobalCss(true);
        } else {
          if (this.itemData.issf == "1" && !this.itemData.jf) {
            if (this.inMiniProgram) {
              this.$toast("请到公众号观看");
            } else {
              this.$toast("请先购买该视频");
            }
            return;
          }
          this.setGlobalCss(false);
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
        this.tabIndex = tab;
      },
      fetch() {
        let params = {
          item_id: this.$route.query.itemId
        };
        let url = `${videoDetail}?item_id=${params.item_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.itemData = res.data.data;
            //console.log(this.itemData, '视频详情')
            this.departmentId = res.data.data.department_id;
            const groupId = res.data.data.group_id;
            if (groupId == 68 && !localStorage.getItem("hasGroupId-" + groupId)) {
              localStorage.setItem("hasGroupId-" + groupId, 1);
              this.isShowDepartImage = true; // 自动弹出
            }

            this.group_id = res.data.data.group_id;
            this.getAmount();
            this.getGroupDetail();
            this.getDouYinList();
            // this.getRelaDis();
            this.getRelativeDoctors();
            this.getRelatedVideos();
            this.getComment();
            const wechat = Wechat.getInstance();
            const data = {
              title: "深读视频精选：" + this.itemData.tag_name.split("-")[0], // 分享标题
              desc: this.itemData.long_name, // 分享描述
              link: decodeURIComponent(location.href), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "https://wx.shendutv.com/images/638667815392809725.png" // 分享图标
            };
            wechat.doSomethingAfterWxConfig(this.$http, wechat.weChatShare(data));
          }
        });
      },
      // 专题详情
      getGroupDetail() {
        let url = subject + "?group_id=" + this.group_id;
        this.$http
          .get(url)
          .then(res => {
            this.groupDetail = res.data.data;
            for (let i = 0; i < this.groupDetail.spjh.length; i++) {
              this.showPlay[i] = false;
              this.showPay[i] = false;
            }
          })
          .then(res => {
            // 播放结束后
            let self = this;
            for (var i = 0; i < this.groupDetail.spjh.length; i++) {
              if (
                self.groupDetail.spjh[i].issf == 1 &&
                self.groupDetail.spjh[i].jf == false
              ) {
                let cvideo = document.getElementsByTagName("video")[i];
                cvideo.addEventListener("ended", function() {
                  Vue.set(self.showPay, self.currentIndex, true);
                  Vue.set(self.showPlay, self.currentIndex, false);
                });
              }
            }
          });
      },
      onFocus() {
        this.sendImg = true;
        this.showMongolia = true;
        // 解决苹果输入框被钉上去的问题
        this.iosBottom = setInterval(function() {
          document.body.scrollTop = document.body.scrollHeight;
        }, 300);
      },
      onBlur() {
        console.log("blur");
        this.sendImg = false;
        const doc = this.$refs["related-swiper-box"];
        clearInterval(doc.timer);
        clearInterval(this.iosBottom);
      },
      // get相关病种
      getRelaDis() {
        let params = {
          department_id: this.departmentId,
          group_id: this.group_id
        };
        let url = `${relatedDisease}?department_id=${
          params.department_id
        }&group_id=${params.group_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.relatedDiseases = res.data.data;
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      goWx(http) {
        window.location.href = http;
      },
      goDetail(val, index) {
        event.stopPropagation();
        this.isShowdouyinVideo = true;
        this.itemId = val;
        this.activeIndex = val;
        // this.$router.go(-1)
        this.$router.push({ path: "/SdDetailVideo", query: { itemId: val } });
        // location.reload()
        this.reload();
      },
      getRelativeDoctors() {
        const url = recommendDoctorWx;
        this.$http
          .get(url, {
            params: {
              group_id: this.group_id
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.relativeDoctors = res.data.data;
            }
          });
      },
      goBack() {
        this.commentInput = "";
        // window.history.go( -1 );
        if (window.history.length <= 1) {
          console.log("返回首页");
          this.$router.push({ path: "/SdSeeDoctor" });
          sessionStorage.removeItem("originRouter");
          return false;
        } else {
          if (
            sessionStorage.getItem("originRouter") == this.$route.query.itemId
          ) {
            console.log("返回首页2");
            this.$router.push({ path: "/SdSeeDoctor" });
            sessionStorage.removeItem("originRouter");
          } else {
            console.log("返回上一页");
            this.$router.go(-1);
          }
        }
      },
      // 跳转底部
      toBottom() {
        let scroll = document.getElementById("comment-list");
        window.scrollTo(0, scroll.offsetTop);
      },
      // 获取评论列表
      getComment() {
        let params = {
          page: 1,
          number: 100,
          group_id: this.group_id // type : 1 病种 2: 抖音
        };
        let url = groupComment;
        this.$http
          .get(url, {
            params
          })
          .then(res => {
            if (res == undefined || res == null) {
              window.reload();
            } else if (res.data.code == 0) {
              this.commentList = res.data.data.list.reverse();
            }
          });
      },
      // 添加评论
      addComment() {
        if (this.commentInput === null || this.commentInput.trim() == "") {
          this.$toast("输入信息为空");
        } else {
          let params = {
            group_id: this.group_id,
            comment: this.utf16toEntities(this.commentInput)
          };
          let url = groupCommetAdd;
          this.$http.post(url, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              this.$toast("留言成功");
              this.closeMongolia();
              this.getComment();
              this.commentInput = "";
              this.toBottom();
              this.$refs.commentRef.blur();
              localStorage.removeItem("commentData-group");
            } else {
              if (res.data.code === 9999) {
                this.$router.push({
                  path: "/SdLogin",
                  query: {
                    redirect: `${this.$route.path}?itemId=${this.itemId}`
                  }
                });
              }
            }
          });
        }
      },
      // 删除评论
      deleteComment(val) {
        let params = {
          id: val
        };
        let url = groupCommetDelete;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("删除成功");
            this.getComment();
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 收藏视频
      collectVideo(val) {
        let url = videoCollectAdd;
        let params = {
          item_id: this.itemId
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.isFavort = true;
            this.$toast("收藏成功");
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 取消收藏视频
      cancleCollectVideo(val) {
        let params = {
          item_id: this.itemId
        };
        let url = videoCollectDelete;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("取消成功");
            this.isFavort = false;
          }
        });
      },
      // 观看历史
      watchHistory() {
        let params = {
          item_id: this.itemId
        };
        let url = addViewHistory;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {});
      },
      goSearch(val) {
        this.$router.push({ path: "/SdSearch", query: { key: val } });
      },
      // 跳转至定向医生详情
      goDoctor(item) {
        // this.$router.push()
      },
      // 相关视频去视频详情
      goVideo(val) {
        this.itemId = val.item_info.item_id;
        this.$router.push({
          path: "/SdDetailVideo",
          query: { itemId: val.item_info.item_id }
        });
        this.reload();
      },
      // 判断是否收藏
      isCollect() {
        let params = {
          item_id: this.$route.query.itemId
        };
        // console.log('collection-item_id',this.$route.query.itemId)
        // let url = `home/video_collect?item_id=${params.item_id}`
        let url = `${videoCollect}?item_id=${params.item_id}`;
        this.$http.get(url).then(res => {
          this.isFavort = res.data.data;
        });
      },
      // 输入框聚焦切换图标
      changeImg() {
        this.sendImg = true;
      },
      // emoji
      utf16toEntities(str) {
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
        str = str.replace(patt, function(char) {
          var H, L, code;
          if (char.length === 2) {
            H = char.charCodeAt(0); // 取出高位
            L = char.charCodeAt(1); // 取出低位
            code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
            return "&#" + code + ";";
          } else {
            return char;
          }
        });
        return str;
      },
      // ===
      testVideo() {
        alert.log("我在点视频aaa ");
      },
      test() {
        let params = this.$refs.playerRef;
        params.onclick = null;
        // alert('...')
      },
      // 点击蒙层输入框失去焦点
      closeMongolia() {
        this.showMongolia = false;
        this.sendImg = false;
        this.$refs.commentRef.blur();
        const doc = this.$refs["related-swiper-box"];
        clearInterval(doc.timer);
        clearInterval(this.iosBottom);
        //this.onBlur()
      },
      // 区人保
      goInsurance() {
        window.location.href = "https://wx.shendutv.com/insurance/renbao";
      },
      // 2019年5月28日21:34:30 周熙孟 临时代码，处理获取不到openid的bug
      urlOpenId() {
        let http = window.location.href;
        console.log("openid http2", http);
        // console.log(!!http.indexOf('openid'), '如果为真的话我就去截取openid哦 false的话说明当前地址没有openid我就要去跳转了吖')
        if (http.indexOf("openid") > -1) {
          let openid = http.split("openid")[1].split("#")[0];
          if (openid) {
            let id = openid.split("=")[1];
            localStorage.setItem("openid", id);
            return id;
            console.log("临时解决方案get openid", id);
            // 还有一种情况要考虑的：openid不在本地，也不在url的时候
          }
          next();
        } else {
          let url = http.split("/")[1];
          // window.location.href = `https://test.shendutv.com/wx/tz?url=${url}` // 测试环境
          window.location.href =
            location.origin + `/wx/tz?url=${encodeURIComponent(url)}`; //正式环境
        }
      }
    }
  };
</script>
<style>
  @import "../../assets/css/emoji.less";
  .emoji-span {
    width: 25px;
    height: 25px;
    display: inline-block;
    border: 1px solid transparent;
    cursor: pointer;
  }
  [class*="sprite-"] {
    width: 25px;
    height: 25px;
    background-image: url("~@/assets/img/common-img/vue-emoji.png");
    background-repeat: no-repeat;
    vertical-align: top;
    display: inline-block;
    background-size: 882.8125px 867.1875px;
    /* transform: scale(1.2, 1.2) */
  }
  #detail-video .van-popup {
    background-color: transparent;
    overflow: hidden;
  }
</style>


<style lang="postcss" scoped>
  .isShowDepart {
    width: 553px;
    height: 628px;
  }
  #detail-video {
    height: 100%;
    background-color: #fffffd;
    /* pointer-events: none; */
    & .mongolia {
      height: 100vh;
      width: 100vw;
      background-color: white;
      opacity: 0;
      /* z-index: 9999; */
      z-index: 10;
      position: fixed;
      top: 0;
    }
    & .top-title {
      width: 100%;
      padding: 27px 0;
      top: 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      z-index: 999999;
      & .back-icon {
        width: 34px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
    }
    & .pay-panel {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      overflow: hidden !important;
      pointer-events: auto;
      background-size: 100%;
      &.pay {
        z-index: 3;
        height: 100%;
        background: url("~@/assets/img/videoDetail/beijing@2x.png") 0 0 no-repeat;
      }
      & p {
        font-family: SourceHanSansCN-Regular;
        color: #fff;
        font-size: 30px;
        position: absolute;
        top: 122px;
        width: 100%;
        text-align: center;
      }
      & .mask {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        position: absolute;
      }
      & .shown-btn {
        width: 308px;
        height: 82px;
        position: absolute;
        left: 20px;
        top: 250px;
      }
      & .shown-btn-inMiniProgram {
        width: 308px;
        height: 82px;
        position: absolute;
        left: 50%;
        top: 250px;
        transform: translateX(-50%);
      }
      & .shown-btn-2 {
        width: 669px;
        height: 92px;
        position: absolute;
        left: 41px;
        top: 300px;
      }
      & .full-watch-btn {
        width: 322px;
        height: 82px;
        right: 20px;
        top: 250px;
        position: absolute;
      }
      & .discount-bg {
        width: 172px;
        height: 29px;
        text-align: center;
        background: url("~@/assets/img/videoDetail/discount-bg.png") 0 0 no-repeat;
        background-size: 100%;
        color: #fff;
        font-family: SourceHanSansCN-Regular;
        position: absolute;
        font-size: 20px;
        line-height: 1.3;
        &.full {
          top: 230px;
          left: 500px;
        }
        &.desc {
          left: 312px;
          top: 242px;
        }
      }
      & .cover-url {
        width: 100%;
        height: 100%;
      }
      & .buy-at-once {
        width: 164px;
        position: absolute;
        left: 50%;
        top: 262px;
        transform: translateX(-50%);
      }
      & .discount-desc {
        width: 172px;
        left: 312px;
        top: 210px;
        position: absolute;
      }
    }
    & .border-wrapper {
      width: 100%;
      & .border-box {
        margin: 0 30px;
        border: 1px solid rgba(215, 215, 215, 1);
      }
    }
    & .title-css {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    & .border-css {
      padding-bottom: 5px;
    }
    & .video-tips {
      position: fixed;
      top: 0;
      width: 100%;
      /* height: 300px; */
      z-index: 2000;
      /* background-color: red; */
      pointer-events: auto;
      & .vbtn {
        width: 60px;
        height: 60px;
        z-index: 999999;
        margin-top: 30px;
        /* background-color: red; */
      }
      & .back-icon {
        margin-left: 30px;
      }
      & .collect-icon {
        margin-left: 479px;
      }
      & .share-icon {
        position: absolute;
        right: 30px;
      }
      & .collect-isweb-icon {
        margin-left: 557px;
      }
      & .eye-box {
        position: absolute;
        bottom: 31px;
        right: 31px;
        display: flex;
        align-items: center;
        font-size: "SourceHanSansCN-Regular";
        color: #fff;
        & .eye-icon {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }
      }
    }
    & .group-view {
      overflow: hidden;
      background-color: #fffffd;
      padding-bottom: 80px;
    }
    & .group-bg {
      position: relative;
      width: 100%;
      height: 359px;
      & .group-overflow {
        width: 1500px;
        height: 100%;
        border-bottom-left-radius: 900px 400px;
        border-bottom-right-radius: 900px 400px;
        overflow: hidden;
        position: absolute;
        bottom: 0px;
        transform: translateX(-25%);
        box-shadow: 0px 0px 50px 0px rgba(80, 82, 88, 0.6);
        & .group-img {
          width: 750px;
          height: 359px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100%;
        }
        & .cover-shadow {
          background-image: url("../../assets/img/groupDetail/covershadow.png");
          background-position: center bottom;
        }
      }
      & img {
        width: 180px;
        height: 180px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%) translateY(50%);
      }
    }
    & .content-box {
      padding: 0 30px;
      padding-bottom: 88px;
      /* padding-top: 400px; */
      &.noBottom {
        padding-bottom: 0;
      }
      background-color: #fffffd;
      /* padding-top: 50px; */
      /* padding-top:550px; */
      //position: absolute;
      //top:530px;
      width: 100%;
      box-sizing: border-box;
      pointer-events: auto;
      /* height: 100%; */
      /* padding-top: 430px; */
      /* border-top:1px solid rgba(215,215,215,1); */
    }
    & .content-box-normal {
      padding: 0 30px;
      background-color: #fffffd;
      & .select-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        background-color: #fffffd;
        & .title-tips {
          font-size: 26px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-left: 20px;
        }
        & img {
          height: 20px;
        }
      }
      &.bottom {
        padding-bottom: 88px;
      }
      &.top {
        padding-top: 50px;
      }
      background-color: #fffffd;
      /* padding-top: 50px; */
      /* padding-top:550px; */
      //position: absolute;
      //top:530px;
      width: 100%;
      box-sizing: border-box;
      pointer-events: auto;
      /* height: 100%; */
      /* padding-top: 430px; */
      /* border-top:1px solid rgba(215,215,215,1); */
    }
    & .video-name-box {
      margin-top: 40px;
      & .video-name {
        font-family: SourceHanSansCN-Bold;
        font-weight: bolder;
        text-align: center;
        /* font-size: 36px; */
        /* font-family: SourceHanSansCN-Bold; */
        /* font-weight: bold; */
        /* color: rgba(51, 51, 51, 1); */
      }
      & .symptom {
        display: flex;
        justify-content: center;
        margin: 26px 0 30px;
        & > div {
          min-width: 76px;
          height: 30px;
          margin: 0 10px;
          border-radius: 30px;
          text-align: center;
          border-width: 2px;
          border-style: solid;
          padding: 0 20px;
          box-sizing: content-box;
          position: relative;
          & .centerH {
            width: 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          & .centerv {
            visibility: hidden;
          }
        }
        & .symptom1 {
          color: #e66b0a;
          background-color: rgba(230, 107, 10, 0.1);
        }
        & .symptom2 {
          color: #ffbf00;
          background-color: rgba(255, 191, 0, 0.1);
        }
        & .symptom3 {
          color: #b8cde6;
          background-color: rgba(184, 205, 230, 0.1);
        }
      }
      & .statis-data:before,
      & .statis-data:after {
        content: "";
        display: block;
      }
      & .statis-data {
        display: flex;
        /* justify-content: space-evenly; */
        justify-content: space-between;
        & > div p {
          text-align: center;
        }
        & > div p:first-child {
          margin-bottom: 15px;
        }
        & > div p:last-child {
          margin-bottom: 5px;
        }
      }
      & .fs-20 {
        font-size: 20px;
      }
      & .fs-24 {
        font-size: 24px;
      }
      & .fs-28 {
        font-size: 28px;
      }
      & .c-333 {
        color: #333;
      }
      & .c-666 {
        color: #666;
      }
      & .more-box {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-top: 25px;
        /* align-items: center; */
        & .name-tips {
          line-height: 40px;
        }
        & .tipsActive {
          /* height: 35px; */
          display: -webkit-box;
          text-overflow: ellipsis;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          -webkit-line-clamp: 3;
          line-height: 40px;
        }
        & .more-icon {
          width: 20px;
          height: 12px;
          margin-top: 3px;
          padding: 10px;
          display: block;
          margin: 0 auto;
        }
        & .more-icon2 {
          width: 20px;
          height: 12px;
          margin-top: 3px;
          padding: 10px;
          display: block;
          margin: 0 auto;
          transform: rotateX(180deg);
        }
      }
      & .go_insurance {
        width: 100%;
        height: 54px;
        border-radius: 50px;
        font-size: 30px;
        font-family: "SourceHanSansCN-Medium";
      }
    }
    & .select-box {
      & .select-title {
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        background-color: #fffffd;
      }
      & .select-video-item-box-wrap {
        font-size: 28px;
        margin-top: 30px;
        margin-bottom: 30px;
        & .select-video-item {
          position: relative;
          min-height: 488px;
          & .symptom-title {
            font-weight: 500;
            font-size: 28px;
          }
        }
        & .symptom-video-bg {
          width: 690px;
          height: 380px;
          border-radius: 10px;
          overflow: hidden;
          margin: 20px 0 30px;
          position: relative;
          & .origin-widgt {
            /* width: 100%; */
            height: 100%;
            border-radius: 10px;
            overflow: hidden;
          }
          & video {
            border-radius: 10px;
          }
          & .symptom-video-img {
          }
          & .icon-play {
            width: 100px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
          }
        }
        & .symptom-summary-title {
          position: relative;
          font-size: 28px;
          margin-bottom: 10px;
          color: #000;
          font-weight: 500;
          & .rich-text {
            position: absolute;
            right: 0;
            top: 100%;
            /* top: 50%; */
            /* transform: translateY(-50%); */
            color: #37bd19;
            font-size: 22px;
            border: 2px solid #37bd19;
            padding: 6px 9px;
            border-radius: 8px;
          }
        }
        & .symptom-summary {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          margin-bottom: 40px;
          color: #666;
          white-space: pre;
        }
      }

      & .select-button {
        margin-top: 30px;
        & .button-wrapper {
          display: flex;
          & .button-item {
            width: 80px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 30px;
            & .button-box {
              height: 80px;
              width: 80px;
              background: rgba(229, 229, 229, 1);
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 26px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              flex-direction: column;
            }
            & .img-text {
              margin-top: 14px;
              font-size: 24px;
              font-family: SourceHanSansCN-Regular;
              color: rgba(51, 51, 51, 1);
              border: 1px solid rgba(215, 215, 215, 1);
              padding: 8px 15px;
              border-radius: 10px;
            }
          }
        }
      }
    }
    & .sorts-box {
      margin-top: 50px;
      & .sorts-name {
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      & .sorts-tips {
        margin: 30px 0 0 0;
        display: flex;
        flex-wrap: wrap;
        & .tips-item {
          /* width: 88px; */
          /* min-width: 80px;
                                                                                                                            max-width: 180px; */
          /* width: 50%; */
          padding: 0 10px;
          height: 36px;
          margin-right: 30px;
          /* border: 1px solid rgba(175, 85, 49, 1); */
          /* border-radius: 8px; */
          font-size: 28px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(175, 85, 49, 1);
          display: flex;
          /* justify-content: center; */
          align-items: center;
          margin-bottom: 20px;
          /* margin-right: 30px; */
          & span {
            border: 1px solid rgba(175, 85, 49, 1);
            border-radius: 8px;
            padding: 0 10px;
            height: 36px;
            line-height: 36px;
            display: flex;
            &.special {
              color: #30747a;
              border-color: #30747a;
            }
            &.normal {
              color: #258714;
              border-color: #258714;
            }
            /* align-items: center; */
          }
        }
        & li:last-child {
          margin-bottom: 0;
        }
      }
      & .sorts-other {
        font-size: 28px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(37, 135, 20, 1);
        border: 1px solid rgba(37, 135, 20, 1);
        border-radius: 8px;
        padding: 3px 10px;
        margin-bottom: 0;
      }
    }
    & .advert-banner {
      border-bottom: 1px solid #d7d7d7;
      & img {
        width: 100%;
        padding: 50px 0;
      }
    }
    /* 有时间可以做出个轮子来，隐藏滚轮的 */
    & .doctor-wrapper {
      overflow-y: hidden;
      height: 320px;
      margin-top: 30px;
      margin-bottom: 20px;
      //margin-top: 50px;
      & .doctor-top5-bg {
        overflow-x: auto;
        white-space: nowrap;
        padding-bottom: 30px;
        & .doctor-top5 {
          box-sizing: border-box;
          width: 310px;
          height: 308px;
          background: rgba(255, 255, 253, 1);
          border: 2px solid rgba(215, 215, 215, 1);
          border-radius: 10px;
          white-space: nowrap;
          display: inline-block;
          margin-right: 30px;
          position: relative;
          overflow: hidden;
          text-align: center;
          box-sizing: content-box;
          & .top-numb-bg {
            width: 100px;
            height: 70px;
            position: absolute;
            right: -7px;
            top: -4px;
            z-index: 1;
          }
          & .top-numb {
            font-size: 20px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            position: absolute;
            right: 8px;
            top: 8px;
            z-index: 2;
          }
          & .doctor-img img {
            width: 88px;
            height: 88px;
            display: block;
            margin: 20px auto;
            border-radius: 50%;
            overflow: hidden;
          }
          & .doctor-name {
            font-size: 28px;
            color: #333;
            font-weight: 700;
          }
          & .doctor-desc {
            margin-top: 10px;
            margin-bottom: 30px;
            font-size: 24px;
            color: #666;
          }
          /* 解决justify-content: space-evenly兼容问题 */
          & .doctor-ask:before,
          & .doctor-ask:after {
            content: "";
            display: block;
          }
          & .doctor-ask {
            display: flex;
            /* justify-content: space-evenly; */
            justify-content: space-between;

            & > div {
              width: 117px;
              height: 58px;
              background: rgba(244, 160, 0, 1);
              box-shadow: 0px 3px 7px 0px rgba(149, 112, 42, 0.4);
              border-radius: 50px;
              color: #fff;
              padding-top: 8px;
              & .ask-numbtext {
                margin-top: 4px;
              }
            }
            & .fs-24 {
              font-size: 24px;
            }
            & .fs-20 {
              font-size: 20px;
            }
          }
        }
        & .doctor-top5:last-child {
          margin-right: 1px;
        }
      }
    }
    & .kownLedge {
      position: relative;
      margin-top: 30px;
      & .icon {
        position: absolute;
        top: -10px;
        left: 0;
        width: 48px;
        height: 48px;
      }
      & a:active {
        color: #37bd19;
      }
      & a {
        font-size: 28px;
        color: #333;
        font-family: SourceHanSansCN-Regular;
        text-align: left;
        width: 613px;
        margin-left: 76px;
        line-height: 40px;
        &.active {
          color: #37bd19;
        }
      }
    }
    & .kownLedge:nth-of-type(1) {
      margin-top: 40px;
    }
    & .kownLedge-more {
      font-size: 24px;
      color: #37bd19;
      margin-top: 30px;
      text-align: center;
      & img {
        width: 22px;
        height: 22px;
        vertical-align: bottom;
      }
    }
    & .other-sorts::before {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      border: 1px solid rgba(215, 215, 215, 1);
      transform: scaleY(0.3);
    }
    & .other-sorts {
      position: relative;
      padding: 0 30px;
      margin-bottom: 60px;
      padding-top: 60px;
      & .scroll-box {
        overflow: hidden;
        //height: 296px;
        width: 100%;
        position: relative;
      }
      & .item-wrapper {
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        /* position: absolute; */
        padding: 20px 0;
        margin: -20px 0;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        display: flex;
        & li:first-child {
          margin-left: 30px;
        }
        & .item-list {
          position: relative;
          width: 100%;
          margin-right: 30px;
          & .video-shdow-wrapper {
            width: 100%;
            height: 100%;
            z-index: 1;
            position: absolute;
            bottom: 60px;
            & .video-shdow {
              width: 320px;
              height: 150px;
              position: absolute;
              bottom: -16px;
              z-index: 1;
            }
          }
          & .img-box {
            margin: 30px 0;
            width: 320px;
            height: 200px;
            border-radius: 10px;
            overflow: hidden;
            /* background-color: red; */
            position: relative;
            /* margin-right: 30px; */
            & .list-img {
              width: 320px;
              height: 200px;
            }
            & .tips {
              position: absolute;
              bottom: 10px;
              right: 10px;
              font-size: 18px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              z-index: 998;
            }
          }
          & .list-name {
            font-size: 28px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
      & .item-wrapper::-webkit-scrollbar {
        display: none;
      }
    }
    & .mask-layout {
      position: fixed;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;
    }
    & .comment {
      padding: 0 30px;
      & .comment-title {
        margin-bottom: 30px;
      }
      & .go-comment {
        position: relative;
        display: flex;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        color: black;
        width: 100%;
        height: 88px;
        box-sizing: border-box;
        padding: 0 30px;
        z-index: 2;
        background-color: rgba(242, 242, 242, 1);
        border: 1px solid rgba(215, 215, 215, 1);
        border-radius: 8px;
        margin-bottom: 40px;
        & .comment-text {
          width: 100%;
          height: 100%;
          background-color: transparent;
          border: none;
          /* border-top: 1px solid rgba(215, 215, 215, 1); */
          box-sizing: border-box;
          padding: 0 70px 0 0px;
        }
        & .heart-icon {
          position: absolute;
          width: 40px;
          right: 30px;
          top: 15px;
          bottom: 30px;
          padding: 10px;
        }
        & .heart-left {
          position: relative;
          width: 40px;
          height: 40px;
          left: 0px;
        }
      }
      & .comment-list {
        & .item-list::before {
          position: absolute;
          top: 0;
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(0.3);
        }
        & .item-list {
          position: relative;
          display: flex;
          padding: 40px 0;
          & .item-left {
            height: 90px;
            width: 90px;
            border-radius: 50%;
            background-color: #e1e2e6;
            & .user-icon {
              width: 90px;
              height: 90px;
              border-radius: 50%;
            }
          }
          & .item-right {
            width: 100%;
            margin-left: 30px;
            & .user-info {
              display: flex;
              width: 100%;
              justify-content: space-between;
              font-size: 32px;
              font-family: SourceHanSansCN-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              & .delete-icon {
                width: 27px;
                height: 27px;
              }
            }
            & .comment-text {
              margin: 21px 0 30px;
              width: 570px;
              word-wrap: break-word;
              /* margin-right: 120px; */
              font-size: 27px;
              line-height: 35px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
            & .comment-time {
              font-size: 20px;
              font-family: SourceHanSansCN-Regular;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
      & .no-more {
        font-size: 24px;
        color: #999;
        text-align: center;
        margin-top: 30px;
      }
    }
    /* & .bottom-shadow {
                                                                                                                        width: 100%;
                                                                                                                        background: url("../../assets/img/common-img/jianbian-xia@2x.png") repeat-x;
                                                                                                                        height: 73px;
                                                                                                                        position: absolute;
                                                                                                                        bottom: 88px;
                                                                                                                      } */

    & .item-bottom {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    & #comment-flag {
      height: 10px;
      visibility: hidden;
    }
    /* & .vcp-controls-panel{
                                                                                                                        display: none;
                                                                                                                      } */
    & .vcp-controls-panel {
      /* height: 50px !important; */
    }
    & .vcp-playtoggle {
      z-index: 9999999;
    }
    & .vcp-panel-bg {
      opacity: 0.5 !important;
    }
    & .activeItem {
      & span {
        color: rgba(55, 189, 25, 1) !important;
      }
    }
    & .test-video {
      width: 100%;
      height: 422px;
    }
    & .line {
      width: 30px;
      height: 4px;
      position: absolute;
      margin: 0;
      margin-top: 12px;
      top: 76px;
      background-color: #37bd19;
      border-radius: 2px;
      &.left {
        left: 172px;
      }
      &.right {
        left: 549px;
      }
    }
    & .related-video-bg {
      margin-top: 40px;
      height: 240px;
      overflow-y: hidden;
      background-color: #fffffd;
      & .related-video-swiper {
        white-space: nowrap;
        overflow-x: auto;
        vertical-align: top;
        padding-bottom: 80px;
        & > div:last-child {
          margin-right: 30px;
        }
        & .video-swiper-item {
          vertical-align: top;
          padding-left: 30px;
          height: 100%;
          display: inline-block;
          & .header::after {
            width: 100%;
            height: 100%;
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            background-image: url("../../assets/img/common-img/video-bottom-shdow@2x.png");
            background-position: bottom;
            background-size: 250%;
            background-repeat: no-repeat;
            z-index: 1;
          }
          & .header {
            display: flex;
            align-content: center;
            align-items: center;
            width: 100%;
            position: relative;
            overflow: hidden;
            position: relative;
            border-radius: 10px;
            & span {
              position: absolute;
              font-size: 22px;
              color: #fff;
              bottom: 14px;
              left: 10px;
              z-index: 2;
            }
            & .avatur {
              width: 320px;
              height: 200px;
              object-fit: cover;
              /* box-shadow:0px 0px 50px 0px rgba(80,82,88,1); */
            }
            & .name {
              font-size: 36px;
              font-family: SourceHanSansCN-Medium;
              color: #333;
            }
          }
          & ul {
            margin-top: 40px;
            & li:last-child {
              margin-bottom: 0;
            }
          }
          & .relative-video-item {
            display: flex;
            align-content: center;
            align-items: center;
            margin-bottom: 20px;
            & img {
              width: 234px;
              height: 123px;
              margin-right: 20px;
              object-fit: cover;
            }
            & > div {
              & .title {
                font-size: 28px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                color: #333;
              }
              & .content {
                margin-top: 16px;
                font-size: 24px;
                font-family: SourceHanSansCN-Regular;
                color: #999;
                width: 357px;
                -webkit-box-orient: vertical;
                overflow: hidden;
                line-height: 1;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
              }
            }
          }
        }
      }
    }
    & .block {
      width: 690px;
      margin: auto;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
    }
    & .block-line {
      border-bottom: 1px solid #d7d7d7;
      margin: auto;
      width: 690px;
      padding: 30px 0;
    }
    & .groupVideosPopUp {
      box-sizing: border-box;
      padding: 0 30px;
      height: 1212px;
      background-color: #fff;
      /* position: fixed; */
      /* left: 0; */
      /* top: 422px; */
      /* z-index: 1000; */
      width: 100%;

      & .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0;
        color: #333333;
        font-size: 32px;
        font-family: SourceHanSansCN-Medium;
        & img {
          width: 24px;
          height: 24px;
        }
      }
      & .items-container {
        position: absolute;
        top: 90px;
        left: 0;
        overscroll-behavior: contain;
        -webkit-overscroll-behavior: contain;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        height: 822px;
        box-sizing: border-box;
        padding: 0 30px;
        width: 100%;
        & > div:last-child {
          padding-bottom: 200px;
        }
      }
      & .items {
        display: flex;
        align-content: center;
        align-items: center;
        margin-bottom: 40px;
        & img {
          width: 268px;
          height: 150px;
          margin-right: 20px;
          object-fit: cover;
        }
        & .title {
          font-family: SourceHanSansCN-Regular;
          color: #333;
          font-size: 28px;
          line-height: 1;
        }
        & .content {
          line-height: 1;
          font-family: SourceHanSansCN-Regular;
          color: #999;
          font-size: 24px;
          margin-top: 30px;
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .share-cover {
    position: fixed;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    img {
      width: 70%;
      margin-top: 15px;
      margin-left: 200px;
    }
  }
  // .popup-enter-active,
  // .popup-leave-active {
  //   animation:popup 1s ease-in;
  //   transition: all 0.5s ease-in;
  // }
  // .popup-leave-active {
  //   transition: all 0.3s ease-out;
  // }
  // .popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
  //   animation:popup 1s reverse ease-out ;
  //   transform: translateY(1000px);
  // }
</style>

<style>
  #detail-video .content-box img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduGroupDetail/SdGroupDetail.vue